// ================================================================================
// Footer accessibility
//
// Accordion: on mobile the footer groups collapse behind a [data-header] button.
// Cornerstone's footer script (theme.js) only toggles an "open" class on that
// button, so the expanded/collapsed state is never announced. We mirror the class
// onto aria-expanded with a MutationObserver, which keeps us out of theme.js.
//
// Opt-out button: OneTrust binds .ot-sdk-show-settings itself and returns focus to
// it when the preference center closes, but overwrites its label with the tenant's
// "Cookies Settings" text once at init. Put the legal wording back.
// ================================================================================

const SELECTOR = '[data-section-type="footer"] [data-header]';
const OPT_OUT_SELECTOR = '[data-section-type="footer"] .ot-sdk-show-settings[data-label]';

function keepLabel(button) {
  if (button.dataset.a11yBound === "true") return;
  button.dataset.a11yBound = "true";

  const template = document.createElement("template");
  template.innerHTML = button.dataset.label;
  const expected = template.content.textContent;

  const restore = () => {
    if (button.textContent !== expected) button.innerHTML = button.dataset.label;
  };

  restore();
  new MutationObserver(restore).observe(button, { childList: true, characterData: true, subtree: true });
}

function syncExpandedState(button) {
  button.setAttribute("aria-expanded", button.classList.contains("open") ? "true" : "false");
}

function watch(button) {
  if (button.dataset.a11yBound === "true") return;
  button.dataset.a11yBound = "true";

  syncExpandedState(button);

  const observer = new MutationObserver(() => syncExpandedState(button));
  observer.observe(button, { attributes: true, attributeFilter: ["class"] });
}

function init(root) {
  (root || document).querySelectorAll(SELECTOR).forEach(watch);
  (root || document).querySelectorAll(OPT_OUT_SELECTOR).forEach(keepLabel);
}

init();

// Re-bind when the footer section is re-rendered in the theme editor
document.addEventListener("shopify:section:load", (evt) => init(evt.target));
